// Function loadSocialBar loads the SocialBar class by dynamically importing the js on demand if needed

export function loadSocialBar($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="SocialBar"]');

	if(!$wg) {
		// console.info('SocialBar: no widget found');
		return Promise.reject('SocialBar widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-social-bar-chunk" */ '../widgets/socialBar').then(wg => {

		const { SocialBar } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="SocialBar"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new SocialBar($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new SocialBar($wg);
		}


	}).catch(error => error+'An error occurred while loading the SocialBar widget');

}
